import { useMutation } from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import { parseErrors } from 'src/app/utilities/helpers/errors';
import ApiResponse from 'src/data/api/responses/ApiResponse';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';
import { TicketDownloadLinkResponse } from 'src/data/services/ticketService';

export const useAccessTicketLinkImportRowLink = (
    onSuccess?: (result: ApiResponse<ApiResponseBody<TicketDownloadLinkResponse>>) => void
) => {
    return useMutation({
        mutationFn: (importRowId: string) =>
            ticketLinkImportService.accessTicketLinkImportRowLink(importRowId),
        onSuccess: (result: ApiResponse<ApiResponseBody<TicketDownloadLinkResponse>>) => {
            onSuccess?.(result);
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};
